module.exports = __webpack_public_path__ + "img/person_blue.9aa924b4.png";